<template>
  <div>
    <Head title="Profili im" />
    <div class="flex justify-start mb-8 max-w-3xl">
      <h1 class="text-3xl font-bold">
        <Link class="text-indigo-400 hover:text-indigo-600">Profili im</Link>
      </h1>
    </div>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.first_name" :error="form.errors.first_name" class="pb-8 pr-6 w-full lg:w-1/2" label="Emri" :disabled="user.role !== 'superadmin'"/>
          <text-input v-model="form.last_name" :error="form.errors.last_name" class="pb-8 pr-6 w-full lg:w-1/2" label="Mbiemri" :disabled="user.role !== 'superadmin'" />
          <text-input v-model="form.email" :error="form.errors.email" class="pb-8 pr-6 w-full lg:w-1/2" label="Email" :disabled="user.role !== 'superadmin'" />
          <text-input v-model="form.phone" :error="form.errors.phone" class="pb-8 pr-6 w-full lg:w-1/2" label="Telefoni" :disabled="user.role !== 'superadmin'" />
          <text-input v-model="form.second_phone" :error="form.errors.second_phone" class="pb-8 pr-6 w-full lg:w-1/2" label="Telefoni sekondar" :disabled="user.role !== 'superadmin'"/>
          <text-input v-model="form.address" :error="form.errors.address" class="pb-8 pr-6 w-full lg:w-1/2" label="Adresa" :disabled="user.role !== 'superadmin'" />
          <text-input v-if="user.role === 'delivery_driver'" v-model="form.personal_number" :error="form.errors.personal_number" class="pb-8 pr-6 w-full lg:w-1/2" label="Numri personal" :disabled="user.role !== 'superadmin'" />


        </div>
        <div v-if="user.role === 'superadmin'" class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Edito</loading-button>
        </div>
      </form>
    </div>


    <h2 v-if="user.businesses.data.length !== 0" class="mt-12 text-2xl font-bold">Bizneset</h2>
    <div v-if="user.businesses.data.length !== 0" id="businesses" class="mt-6 bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6">Emri i biznesit</th>
          <th class="pb-4 pt-6 px-6">Numri i biznesit</th>
          <th class="pb-4 pt-6 px-6">Telefoni i biznesit</th>
          <th class="pb-4 pt-6 px-6">Adresa (primare)</th>
          <th class="pb-4 pt-6 px-6">Qyteti (primar)</th>
          <th class="pb-4 pt-6 px-6">Regjioni (primar)</th>
          <th class="pb-4 pt-6 px-6">Krijuar më</th>
          <th class="pb-4 pt-6 px-6">Edituar më</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="business in user.businesses.data" :key="business.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/admin/bizneset/${business.id}/edit`">
              {{ business.name }}
              <icon v-if="business.primary" name="primary" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />

            </Link>
          </td>

          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-indigo-500">
              {{ business.number }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-indigo-500" >
              {{ business.phone }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-indigo-500">
              {{ business.location !=null ? business.location.name : null}}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-indigo-500">
              {{ business.location !=null ? business.location.city.name : null}}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-indigo-500">
              {{ business.location !=null ? business.location.region.name : null}}
            </Link>
          </td>

          <td class="border-t">
            <Link class="flex items-center px-6 py-4">
              {{ business.hr_created_at }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" >
              {{ business.hr_updated_at }}
            </Link>
          </td>
          <td class="w-px border-t">
            <Link class="flex items-center px-4">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>
        </tr>
        <tr v-if="user.businesses.data.length === 0">
          <td class="px-6 py-4 border-t" colspan="4">Nuk u gjet asnje biznes.</td>
        </tr>
        </tbody>
      </table>
    </div>



    <h2 v-if="user.businesses.data.length !== 0" class="mt-12 mb-5 text-2xl font-bold">Lokacionet</h2>

    <div v-if="user.businesses.data.length !== 0" class="mt-6 bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6">Emri i lokacionit</th>
          <th class="pb-4 pt-6 px-6">Biznesi</th>
          <th class="pb-4 pt-6 px-6">Qyteti</th>
          <th class="pb-4 pt-6 px-6">Adresa</th>
          <th class="pb-4 pt-6 px-6">Krijuar më</th>
          <th class="pb-4 pt-6 px-6">Edituar më</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="location in user.locations.data" :key="location.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-indigo-500" >
              {{ location.name }}
              <icon v-if="location.primary" name="primary" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400"/>
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-indigo-500" >
              {{ location.business_name }}
              <icon v-if="location.primary" name="primary" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400"/>
            </Link>
          </td>

          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-indigo-500"

            >
              {{ location.city.name }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-indigo-500"

            >
              {{ location.address }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-indigo-500"

            >
              {{ location.hr_created_at }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-indigo-500"

            >
              {{ location.hr_updated_at }}
            </Link>
          </td>
        </tr>
        <tr v-if="user.locations.data.length === 0">
          <td class="px-6 py-4 border-t" colspan="4">Nuk u gjet asnje lokacion.</td>
        </tr>
        </tbody>
      </table>
    </div>



  </div>
</template>

<script>
import {Head, Link, usePage} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import Icon from '@/Shared/Icon'
export default {
  components: {
    FileInput,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    Icon
  },
  layout: Layout,
  props: {
    user: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        id: this.user.id,
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        email: this.user.email,
        phone: this.user.phone,
        second_phone: this.user.second_phone,
        address: this.user.address,
        personal_number: this.user.personal_number,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(`/profili`)
    },
  },
}
</script>
